import Cookies from 'js-cookie';
import { cultureRegexString } from 'core-framework/localization/culture';
import { pathname } from 'core-framework/window/location';
import { Currency } from 'core/localization/currency';

export const versionCookieName = 'agoda.version.03';

export const deserializeCookie = (cookie?: string, keyValuePairSeparator = '&', keyValueSeparator = '='): Record<string, string> => {
    if (!cookie) {
        return {};
    }

    const keyValuePairs = cookie.split(keyValuePairSeparator);

    return keyValuePairs.reduce<{ [key: string]: string }>((previous, current) => {
        if (current && current.includes(keyValueSeparator)) {
            const keyValuePair = current.split(keyValueSeparator);
            if (keyValuePair[0]) {
                previous[keyValuePair[0]] = keyValuePair.length > 1 ? keyValuePair[1] : '';
            }
        }
        return previous;
    }, {});
};

export const readHybridModeCookies = (): {
    languageCode: string | null;
    currencyCode: string | null;
} => {
    const cookie = Cookies.get(versionCookieName);
    const values = deserializeCookie(cookie);

    if (!values || !Object.keys(values).length) {
        return {
            languageCode: null,
            currencyCode: null,
        };
    }

    return {
        languageCode: values.DLang || values.CulCd,
        currencyCode: values.CurLabel,
    };
};

export const getDefaultCurrency = (): Currency => {
    const hybridModeCookies = readHybridModeCookies();
    const defaultCurrency: Currency = hybridModeCookies.currencyCode
        ? {
              id: 0,
              name: '',
              code: hybridModeCookies.currencyCode,
              isSuggested: false,
              symbol: '',
              displayCode: hybridModeCookies.currencyCode,
              exchangeRate: 0,
              numberOfDecimal: 2,
              onBack: true,
          }
        : { id: 7, name: 'US Dollar', code: 'USD', isSuggested: false, symbol: '$', displayCode: 'USD', exchangeRate: 1, numberOfDecimal: 2, onBack: true };
    return defaultCurrency;
};

export const getDefaultCultureCode = () => {
    const cookieCulture = readHybridModeCookies().languageCode;
    const cultureMatch = pathname().match(`^/(${cultureRegexString})`);
    const cultureCode = cookieCulture || (cultureMatch != null && cultureMatch.length > 1 ? cultureMatch[1] : '*');
    return cultureCode;
};

export const getCurrencyAndCultureCode = () => {
    const language = getDefaultCultureCode();
    const currencyCode = getDefaultCurrency().code;
    return {
        currencyCode,
        language,
    };
};
